var map = {
	"./boa.png": 4516,
	"./bundo.png": 7089,
	"./federal.png": 2328,
	"./gorilla.jpg": 8202,
	"./hellooriental.png": 5901,
	"./pep.png": 53,
	"./poutinepunks.png": 5368,
	"./scicillian.png": 2817,
	"./seitans.jpg": 1036,
	"./shoe.png": 5883,
	"./tarricrii.png": 3573,
	"./trippychip.jpg": 857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;